import React from 'react'

import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {EventosCarruselItem} from './EventosCarruselItem'

function EventosCarrusel(props) {
  const displayItems = (props) => {
    if (props) {
      const eventos = props.eventos

      console.log(eventos)
      if (eventos) {
        if (eventos.length > 0) {
          return eventos.map((evento, index) => {
            return (
              <EventosCarruselItem
                key={index}
                evento={evento}
                deleteEvento={props.deleteEvento}
                setEventosCarrusel={props.setEventosCarrusel}
              />
            )
          })
        } else {
          return <h3>No hay eventos</h3>
        }
      } else {
        return <h3>No hay eventos</h3>
      }
    } else {
      return <h3>No hay eventos</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {EventosCarrusel}
